/* eslint semi:0 */
import { noop, } from '../../jsCore/utils/fn'
import { node, } from '../../jsCore/utils/dom'
import { warn, } from '../../jsCore/application/console'
import { SELECTORS, } from '../../jsCore/config/preRenderedSelectorsConfig'
import { isSupportedForDomain, } from '../../jsCore/application/pageDataObject'


const HAMBURGER_FEATURE_ID = 'HamburgerMenu'
const HAMBURGER_CLASS_NAMES = {
  NO_SCROLL: 'no-scroll',
}
const CHECKED_MENU_RADIO_BUTTON_SELECTOR = "input[name=leagues-list-radio]:checked"


function uncheckCheckedSidenav(sideNav, e){
  if (sideNav.checkbox && sideNav.checkbox.checked) {
    sideNav.hamburger.click()
    const checkedMenuButton = node(CHECKED_MENU_RADIO_BUTTON_SELECTOR)
    if (checkedMenuButton) {
      checkedMenuButton.checked = false
    }
  }
}

function menuClickHandler(sideNav, e){
  document.body.classList.toggle(
    HAMBURGER_CLASS_NAMES.NO_SCROLL,
    sideNav.checkbox.checked
  )
  e.stopPropagation()
}

function registerClickEvents(sideNav, element){
  if (!element) {
    warn('[hamburger] registerClickEvents got a falsy element', { sideNav, element, })
    return noop
  }
  const partiallyAppliedClickHandler = menuClickHandler.bind(0, sideNav)
  element.addEventListener('click', partiallyAppliedClickHandler)
  return partiallyAppliedClickHandler
}

function addHamburgerEventListeners(){
  const sideNav = {
    headerNode: node(SELECTORS.SITE_HEADER),
    checkbox: node(SELECTORS.MAIN_SIDENAV_CHECKBOX),
    hamburger: node(SELECTORS.MAIN_SIDENAV_TOGGLE),
    menu: node(SELECTORS.MAIN_SIDENAV),
  }
  document.body.addEventListener('click', uncheckCheckedSidenav.bind(0, sideNav))
  const clickEventTargets = [sideNav.menu, sideNav.hamburger, sideNav.checkbox, ]
  return clickEventTargets.map(registerClickEvents.bind(0, sideNav))
}

export function registerHamburger(){
  const shouldInitHamburgerMenu = isSupportedForDomain(HAMBURGER_FEATURE_ID)
  if (shouldInitHamburgerMenu) {
    addHamburgerEventListeners()
  }
  return shouldInitHamburgerMenu
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/hamburger/hamburger.js